<template>
    <div v-if="null != order">
        <v-card>
            <v-card-subtitle class="d-flex align-center">
                Order #{{ order.id }}
                <v-chip
                    small
                    label
                    class="ml-auto"
                    v-bind:color="getChipColor(order.status)"
                    >{{ order.status }}</v-chip
                >
            </v-card-subtitle>
            <v-divider />
            <v-card-actions class="d-flex mx-2">
                <v-spacer />
                <v-btn tile v-bind:disabled="!canEdit" v-on:click="editOrder"
                    ><v-icon left>mdi-pencil</v-icon>Edit</v-btn
                >
                <v-btn
                    tile
                    color="error"
                    v-bind:disabled="!canDelete"
                    v-on:click="deleteOrder"
                    ><v-icon left>mdi-delete</v-icon>Delete</v-btn
                >
            </v-card-actions>
        </v-card>
        <order-show-detail v-bind:order="order" />
    </div>
</template>

<script>
import orderApi from '@/api/orderApi';
import roleUtil from '@/utils/roleUtil';
import snackbar from '@/utils/snackbar';
import statusUtil from '@/utils/statusUtil';

export default {
    components: {
        'order-show-detail': () => import('@/views/rest/OrderShowDetail.vue')
    },
    data() {
        return {
            order: null
        };
    },
    computed: {
        canEdit() {
            return roleUtil.canRestaurateurEditOrder(this.order);
        },
        canDelete() {
            return roleUtil.canRestaurateurDeleteOrder(this.order);
        }
    },
    async beforeRouteEnter(to, from, next) {
        const orderId = to.params.order_id;
        const response = await orderApi.getOrder(orderId);
        next(vm => (vm.order = response.data.order));
    },
    methods: {
        editOrder() {
            this.$router.push({
                name: 'rest-order-edit',
                params: {
                    order_id: this.order.id
                }
            });
        },
        async deleteOrder() {
            const confirmed = confirm('Confirm deletion');
            if (!confirmed) return;
            await orderApi.deleteOrder(this.order.id);
            this.$router.push({ name: 'rest-order-list' });
            snackbar.show('Deleted successfully', 'success');
        },
        getChipColor(status) {
            return statusUtil.getOrderStatusColor(status);
        }
    }
};
</script>
